module.exports = __webpack_public_path__ + "img/fastcar.325922f3.png";